import React from "react";
import { apiRoutes } from "../../../hooks/apiClient";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import DetalhamentoTipoDivergencia from "./DetalhamentoTipoDivergencia";

const ConsultaTipoDivergencia = ({ history, match }) => {
  const columns = [
    {
      name: "Sigla",
      selector: "sgTipoAutomacao",
      width: "20%",
      sortable: true,
    },
    {
      name: "Nome",
      selector: "dsTipoAutomacao",
      sortable: true,
    },
  ];

  return (
    <PaginatedView
      title="Tipos de Divergência"
      keyField="sqTipoAutomacao"
      descriptionField="dsTipoAutomacao"
      defaultSearch
      defaultSearchPlaceholder="Digite o Nome"
      queryService={apiRoutes.fiscalizacao.parametrizacao.consultaTipoDivergencia}
      editRoute={`${match.url}/form`}
      deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiTipoDivergencia}
      columns={columns}
      expandComponent={DetalhamentoTipoDivergencia}
      permissionInsert={funcionalidades.tipoDivergencia.inserir}
      permissionDelete={funcionalidades.tipoDivergencia.deletar}
      history={history}
    />
  );
};

export default ConsultaTipoDivergencia;
